import { create, show, useModal } from "@ebay/nice-modal-react";

import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";
import useDeleteSpaceliftVcsRepo from "shared/SpaceliftVcsRepo/useDeleteSpaceliftVcsRepo";

type DeleteSpaceliftVcsRepoConfirmationProps = {
  id: string;
  name: string;
  onSuccess?: () => void;
};

const DeleteSpaceliftVcsRepoConfirmation = create(function DeleteConfirmation({
  id,
  name,
  onSuccess,
}: DeleteSpaceliftVcsRepoConfirmationProps) {
  const modal = useModal();
  const { deleteSpaceliftVcsRepo, loading } = useDeleteSpaceliftVcsRepo();

  const handleConfirm = () => {
    deleteSpaceliftVcsRepo(id, () => {
      modal.hide();
      onSuccess?.();
    });
  };

  return (
    <DeleteConfirmationModal
      title="Delete repo"
      name={name}
      onConfirm={handleConfirm}
      isLoading={loading}
      isDismissable={!loading}
    />
  );
});

export const showDeleteSpaceliftVcsRepoConfirmation = (
  props: DeleteSpaceliftVcsRepoConfirmationProps
) => show(DeleteSpaceliftVcsRepoConfirmation, props);
